export default "__VITE_ASSET__guv5fFUu__"